import APIrequest from "../lib/axios";

export const MediaServices = {
    async uploadMedia(file, mediaType = "image", mediaFor = "committee") {
        try {
            const formData = new FormData();
            formData.append("image", file);

            const payload = {
                method: "post",
                url: `/media/upload/${mediaType}/${mediaFor}`,
                bodyData: formData
            };
            const res = await APIrequest(payload);
            return res; // Returns the media record
        } catch (error) {
            console.log(error);
            return null;
        }
    }
};
